export default "__VITE_ASSET__WfGDtIs2__"